import { render } from "./Mb034.vue?vue&type=template&id=85809532"
import script from "./Mb034.vue?vue&type=script&lang=js"
export * from "./Mb034.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__